import { ProberAudioProfile, ProberVideoProfile } from '../models';

export const defaultTimeout = '20s';

export const setProberProfilesIndexForRtmp = (profiles: (ProberAudioProfile | ProberVideoProfile)[]) => {
  profiles.forEach((profile, index) => (profile.id = index));
};
